import React from "react";
import { Link, useParams } from "react-router-dom";
import EditClientSpecificReport from "./EditClientSpecificReport";
import { useGetReportResourceById } from "../../../../../reactQueries/AppApi/rqHooksForClientSpecificReports";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";

const EditClientSpecificReportHome = () => {
  let { id } = useParams();
  const {
    data: dataById,
    isError: isErrorOnReportResourceById,
    isFetching: isFetchingOnReportResourceById,
    isSuccess: isSuccessOnReportResourceById,
    error: errorOnReportResourceById,
  } = useGetReportResourceById({ reportResourceId: id });

  return (
    <div>
      {
        !!isFetchingOnReportResourceById && "Wait, Loading...."
      }
      {!!isSuccessOnReportResourceById && (
        <EditClientSpecificReport clientSpecificReportDataById={dataById} />
      )}

      <MpgErrorDialog
        open={!!isErrorOnReportResourceById}
      />
    </div>
  );
};

export default EditClientSpecificReportHome;
